import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { fetchSubscriptionActivateUserApi, fetchSubscriptionRequestActivation } from "../../api/api"; 

const ActivationPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [statusMessage, setStatusMessage] = useState("Activating your account...");
  const [isError, setIsError] = useState(false);
  const [showResendForm, setShowResendForm] = useState(false);
  const [email, setEmail] = useState("");
  const [resendStatus, setResendStatus] = useState("");

  useEffect(() => {
    const emailParam = searchParams.get("uname");
    const uuidParam = searchParams.get("uuid");
    const tokenParam = searchParams.get("token");

    if (!emailParam || !uuidParam) {
      setStatusMessage("Invalid activation link.");
      setIsError(true);
      setShowResendForm(true);
      return;
    }

    const activateUser = async () => {
      try {
        const res = await fetchSubscriptionActivateUserApi(emailParam, uuidParam, tokenParam);

        if (res?.statuscode === 200) {
          setStatusMessage("✅ Your account has been activated. Redirecting to login...");
          setTimeout(() => navigate("/login"), 2000);
        } else {
          setStatusMessage(res?.message || "❌ Activation failed. Please request a new activation link.");
          setIsError(true);
          setShowResendForm(true);
        }
      } catch (err) {
        setStatusMessage("❌ Error activating your account. Please try again later.");
        setIsError(true);
        setShowResendForm(true);
      }
    };

    activateUser();
  }, [navigate, searchParams]);

  const handleResendLink = async (e) => {
    e.preventDefault();
    setResendStatus("Sending activation link...");
    setStatusMessage("")
    try {
      const res = await fetchSubscriptionRequestActivation(email); 
      if (res?.statuscode === 200) {
        setResendStatus("✅ Activation link sent to your email.");
      } else {
        setResendStatus(res?.message || "❌ Failed to send activation link.");
      }
    } catch (error) {
      setResendStatus("❌ Error sending activation link.");
    }
  };

  return (
  <div className="login-container">
    <div className="login-form">
      <h2>
        {isError
          ? "Activation Failed"
          : "Account Activation"}
      </h2>

      <p style={{ textAlign: "center", color: isError ? "red" : "green" }}>
        {statusMessage}
      </p>

      {isError && (
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ textAlign: "center" }}>Request New Activation Link</h3>
          <form onSubmit={handleResendLink}>
            <input
              type="email"
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
            />
            <button type="submit" style={{ width: "100%", padding: "10px" }}>
              Send Activation Link
            </button>
          </form>
          {resendStatus && (
            <p
              style={{
                marginTop: "10px",
                textAlign: "center",
                color: resendStatus.includes("✅") ? "green" : "red",
              }}
            >
              {resendStatus}
            </p>
          )}
        </div>
      )}
    </div>
  </div>
);


};

export default ActivationPage;
